<template>
  <div>
    <v-dialog
      @keydown.esc="dialog=false"
      max-width="500"
      v-model="dialog"
      persistent>
      <v-card>
        <v-card-title>
          <div class="d-flex">
            <div class="primary--text">
              Facturas de order de compra: {{ order.uuid }}
            </div>
            <v-spacer />
            <v-btn
              color="black darken-1"
              @click="close"
              text
              icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-form v-model="form.isValid" ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6 sm6 md6 class="d-flex align-center">
                  <v-file-input
                    v-model="form.data.xmlFiles"
                    multiple
                    label="XML File"
                    accept=".xml"
                    required>
                  </v-file-input>
                </v-flex>
                <v-flex xs6 sm6 md6 class="d-flex align-center justify-end">
                  <v-btn
                    :disabled="disabled"
                    color="success"
                    rounded
                    @click="upload">
                    Subir
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="999999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: 'AttachInvoice',
  props: ['dialog', 'order'],
  data () {
    return {
      overlay: false,
      invoiceValid: null,
      form: {
        isValid: false,
        data: {
          xmlFiles: []
        }
      }
    }
  },
  computed: {
    disabled () {
      return !(this.form.isValid)
    }
  },
  methods: {
    upload: async function () {
      try {
        this.overlay = true
        await this.$api.post(`/v1/orders/${this.order._id}/attach-invoice`,
          this.form.data,
          { delivery: 'formData' })
        this.close()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    close () {
      this.$refs.form.reset()
      this.form.data = { xmlFiles: [] }
      this.$emit('close')
    }
  }
}
</script>
